import React from 'react'
import Banners from '../../Components/Banners/Banners'
import Products from '../../Components/Products/Products'
import './Demo.css'
import Footer from '../../Components/Footer/Footer'
import BtnWhatsapp from '../../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../../Components/Cart/Cart'
import BannersMore from '../../Components/BannersMore/BannersMore'
import StoreSidebar from '../../Components/StoreSidebar/StoreSidebar'
export default function Demo() {
    return (
        <section className='demo'>
            <Banners />
            {/* <BannersMore/> */}
            
            <div className='demo-content-row'>
                <StoreSidebar />
                <Products />
            </div>
            <Footer />
          
            <BtnWhatsapp />
            <Cart />
        </section>
    )
}
